import { render, staticRenderFns } from "./FlexTable.vue?vue&type=template&id=67bedf5e&scoped=true&"
import script from "./FlexTable.vue?vue&type=script&lang=js&"
export * from "./FlexTable.vue?vue&type=script&lang=js&"
import style0 from "./FlexTable.vue?vue&type=style&index=0&id=67bedf5e&lang=sass&scoped=true&"
import style1 from "./FlexTable.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bedf5e",
  null
  
)

export default component.exports